import { makeStyles } from "@material-ui/core";
import { colors } from "@utils/constant";

const ViewLogStyle = makeStyles({
	ViewLogWrapper: {
		"& .custom-datepicker": {
			"& .MuiInput-root": {
				"& .MuiIconButton-root": {
					right: "15px",
				},
			},
		},
    "& .title-panel": {
      "& h1": {
        color: colors.black,
        margin: "0 20px 0 0",
        fontSize: "30px",
        textTransform: "capitalize"
      }
    },
    "& .summary-holder": {
      marginTop: "30px",
      "& .summary": {
        border: "1px solid #5fa4fc",
        background: colors.blurBlue,
        borderRadius: "10px",
        padding: "30px",
        "@media(max-width:767px)": {
          padding: "15px",
        },
        "& .title": {
          color: colors.darkBlue1,
          marginBottom: "15px",
          fontWeight: "bold",
          fontSize: "17px",
        },
        "& .content": {
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "stretch",
          flexDirection: "row",
          "@media(max-width:767px)": {
            width: "100%",
            flexDirection: "column"
          },
          "& .section": {
            flexGrow: 1,
            paddingBottom: 0,
            flexBasis: "min-content",
            "@media(max-width:767px)": {
              paddingBottom: "15px",
            },
            "&:last-child": {
              flexGrow: 1,
              paddingBottom: 0,
              maxWidth: "300px",
              "@media(max-width:767px)": {
                paddingBottom: "0",
                maxWidth: "100%",
              }
            },
            "& header": {
              color: colors.gray1,
              fontSize: "14px",
            },
            "& b": {
              display: "block",
              paddingRight: "15px"
            }
          }
        }
      }
    },
    "& .detail-holder": {
      marginTop: "30px",
      "& .detail": {
        border: "1px solid #ffffff",
        background: colors.white,
        borderRadius: "10px",
        padding: "30px",
        boxShadow: "0px 4px 5px #bbbbbb",
        "@media(max-width:767px)": {
          padding: "15px",
        },
        "& .title": {
          marginBottom: "35px",
          fontWeight: "bold",
          fontSize: "25px",
          lineHeight: 1,
        },
        "& .content": {
          color: colors.darkGray,
          "& table": {
            borderCollapse: "collapse",
            "& tr": {
              "& td": {
                verticalAlign: "top",
                "&.list": {
                  paddingLeft: "45px",
                  paddingTop: "5px",
                  "@media(max-width:767px)": {
                    paddingLeft: "20px",
                  },
                  "& ul": {
                    listStyle: "inside",
                    "& li": {
                      paddingBottom: 10,
                      "@media(max-width:550px)": {
                        paddingBottom: "12px",
                      },
                      "&:last-child": {
                        paddingBottom: 0,
                      },
                      "& .break": {
                        display: "inline-block",
                        "@media(max-width:550px)": {
                          display: "block",
                        }
                      },
                      "& ul": {
                        "&.child-invoice": {
                          paddingLeft: 22,
                          "& li": {
                            paddingBottom: 0
                          }
                        }
                      }
                    }
                  },
                  "& b": {
                    "& a": {
                      "&:link, &:visited, &:active": {
                        color: colors.darkBlue2,
                        fontWeight: 600,
                      }
                    }
                  },
                  "&.job": {
                    "& ul li": {
                      paddingBottom: 0,
                    }
                  }
                },
                "&.first": {
                  position: "relative",
                  width: "16px",
                  paddingTop: "3px",
                  "& .circle": {
                    width: "16px",
                    height: "16px",
                    borderRadius: "100%",
                    position: "relative",
                    zIndex: "3",
                    "&.updated-color": {
                      background: colors.orange,
                    },
                    "&.expired-color": {
                      background: colors.orange,
                    },
                    "&.rejected-color": {
                      background: colors.darkRed2,
                    },
                    "&.generated-color": {
                      background: colors.darkBlue2,
                    },
                    "&.recalculated-color": {
                      background: colors.sky,
                    }
                  },
                  "& .eraser": {
                    width: "16px",
                    height: "6px",
                    background: colors.white,
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    marginLeft: "-8px",
                    zIndex: "2",
                  },
                  "& .line": {
                    height: "100%",
                    width: "1px",
                    background: colors.black3,
                    position: "absolute",
                    top: "0",
                    bottom: "0",
                    left: "50%",
                    marginLeft: "-0.5px",
                    zIndex: "1"
                  },
                },
                "&.second": {
                  paddingLeft: "15px",
                  "& .header": {
                    color: colors.gray8,
                    fontWeight: "600",
                    "& .mobile": {
                      display: "none",
                      "@media(max-width:767px)": {
                        display: "block",
                      }
                    }
                  },
                  "& .info": {
                    "& b": {
                      display: "inline-block",
                    }
                  },
                  "&.updated": {
                    "& span": {
                      color: colors.green2,
                      fontWeight: "bold",
                    }
                  },
                  "&.expired": {
                    "& span": {
                      color: colors.red2,
                      fontWeight: "bold",
                    }
                  }
                },
                "&.third": {
                  width: "300px",
                  "@media(max-width:767px)": {
                    display: "none",
                  }
                }
              }
            },
            "& .space": {
              height: "40px"
            }
          },
          "& b": {
            fontWeight: 600
          },
          "& .negative": {
            color: colors.red,
          }
        }
      }
    }
	},
  backLinkWrapper: {
    marginBottom: "5px",
    "& a": {
      fontSize: "18px",
      lineHeight: "1.2",
      position: "relative",
      fontWeight: "500",
      color: colors.orange,
      display: "inline-flex",
      alignItems: "center",
      "& svg": {
        height: 15,
        width: 15,
      },
    },
  },
});

export { ViewLogStyle };
